import React, { useState } from 'react';
import { Amplify } from 'aws-amplify';
import { Authenticator, useTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import '../../aws-exports'; 
import awsExports from '../../aws-exports';

import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';


Amplify.configure(awsExports);

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <div style={{ padding: `${tokens.space.xl} 0` }}>
        {/* You can add your logo or header content here */}
        <h1 style={{ textAlign: 'center' }}>Sign in or create an account</h1>
      </div>
    );
  },

  Footer() {
    const { tokens } = useTheme();

    return (
      <div style={{ padding: `${tokens.space.xl} 0` }}>
        {/* You can add your footer content here */}
        <p style={{ textAlign: 'center' }}>&copy; 2023 Your Company</p>
      </div>
    );
  },

  SignIn: {
    Header() {
      const { tokens } = useTheme();

      return (
        <h2 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Sign In to your Account</h2>
      );
    },
    Footer() {
      const { tokens } = useTheme();

      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>Forgot your password?</p>
      );
    },
  },

  SignUp: {
    Header() {
      const { tokens } = useTheme();

      return (
        <h2 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Create a New Account</h2>
      );
    },
    Footer() {
      const { tokens } = useTheme();

      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>Already have an account?</p>
      );
    },
  },
  ConfirmSignUp: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Enter Confirmation Code</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Lost your code? {/* Add resend code functionality */}
        </p>
      );
    },
  },
  SetupTOTP: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Setup TOTP</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Need help setting up TOTP? {/* Add link to help */}
        </p>
      );
    },
  },
  ConfirmSignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Confirm Sign In</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Need help confirming sign in? {/* Add link to help */}
        </p>
      );
    },
  },
  ForceNewPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Create New Password</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Need help creating a new password? {/* Add link to help */}
        </p>
      );
    },
  },
  ResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Reset Password</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Need help resetting your password? {/* Add link to help */}
        </p>
      );
    },
  },
  ConfirmResetPassword: {
    Header() {
      const { tokens } = useTheme();
      return (
        <h3 style={{ padding: `${tokens.space.xl} 0 0 ${tokens.space.xl}` }}>Confirm Reset Password</h3>
      );
    },
    Footer() {
      const { tokens } = useTheme();
      return (
        <p style={{ padding: `0 ${tokens.space.xl} ${tokens.space.xl}` }}>
          Need help confirming your password reset? {/* Add link to help */}
        </p>
      );
    },
  },
};

const formFields = {
  signUp: {
    name: {
      order: 1,
      label: 'Full Name',
      placeholder: 'Enter your full name',
      isRequired: true,
    },
    phone_number: {
      order: 3,
      label: 'Phone Number',
      placeholder: 'Enter your phone number',
      isRequired: true,
    },
  },
};

const services = {
  async validateCustomSignUp(fieldName, value) {
    if (fieldName === 'name') {
      if (value.length < 5) {
        return 'Name must be at least 5 characters long.';
      }
    }
    if (fieldName === 'phone_number') {
        if (value.length < 10) {
            return 'Phone number must be at least 10 digits long.';
          }
        }
  },
};

// const AuthPage = () => {
//   return (

//     <Authenticator
//       formFields={formFields}
//       components={components}
//       services={services}
//       socialProviders={['google']}
//     >
//       {({ signOut, user }) => (
//         <main>
//           <h1>Hello {user.username}</h1>
//           <button onClick={signOut}>Sign out</button>
//         </main>
//       )}
//     </Authenticator>
//   );
// };
const AuthPage = () => {
return (
  <>
    <Header /> {/* Your custom Header */}
    <Authenticator
      formFields={formFields}
      components={components}
      services={services}
      socialProviders={['google']}
    >
      {({ signOut, user }) => (
        <main style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Hello {user.username}</h1>
          <button onClick={signOut}>Sign out</button>
        </main>
      )}
    </Authenticator>
    <Footer /> 
  </>
);
};

export default AuthPage;
